#rass-data-reknr {
  --rds-form-elements-input-error-margin-block-start: 3px;
  --rds-form-elements-margin: 0;
  white-space: nowrap;
}

#rass-data-reknr .rds-input__input {
  padding: 0 var(--rds-form-elements-padding-inline, 16px) 0 0;
}

#rass-data-reknr .rds-input--state-has-errors {
  margin-bottom: 0;
}

#rass-data-prefix {
  padding-left: var(--rds-form-elements-padding-inline, 16px);
  white-space: nowrap;
  color: var(--rds-form-elements-color-text, #202122);
  user-select: none;
}

#rass-data-prefix + input {
  padding-left: 0;
  --rds-form-elements-padding-inline: 0;
}
